import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import wrap from './components/view-wrap/view-wrap.vue'
import axios from 'axios'

Vue.use(VueScrollTo)

Vue.component('view-wrap', wrap);

Vue.prototype.$http = axios;

Vue.mixin({
  data() {
    return {
      ENV: {
        token: 'pk_test_VtIQiEgU1ULUXiLquwd8kzG900mSvfOXg0'
      },
      external: {
        twitter: 'https://www.twitter.com/fantasytoolbox',
        facebook: '',
        instagram: ''
      }
    }
  },
  methods: {}
})

// global components
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
